module.exports = __webpack_public_path__ + "media/photo/electric_idea-ba2e0ee4.png";